import { directionOf, type LanguageCode } from "./languages";

/** Points the page at the chosen language: `<html lang>` and text direction. */
export function applyDocumentLanguage(code: LanguageCode): void {
    if (typeof document === "undefined") return;
    document.documentElement.setAttribute("lang", code);
    document.documentElement.setAttribute("dir", directionOf(code));
}
